/**
 * Data center flooring (raised floor?) UI options.
 *
 * #1012 Item 1: storage canonicalized to ['Yes', 'No']. The legacy
 * `siteFlooringToYesNo` / `yesNoToSiteFlooring` converters and the
 * `'Raised'` / `'Slab'` storage vocabulary are gone — migration 084
 * backfills existing rows.
 */
export const RAISED_FLOORING_YES_NO: readonly [string, string] = ['Yes', 'No'];
